// API Configuration for Line4.Observability

const getApiBaseUrl = (): string => {
  // Always use production API (deployed on api.line4.ai)
  // Override with VITE_API_URL env var if you need to test with local Vercel dev
  return import.meta.env.VITE_API_URL || 'https://api.line4.ai/api';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  ENDPOINTS: {
    // Authentication
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    
    // Health & Status
    HEALTH: '/health',
    MIGRATE: '/migrate',
    
    // Risk Management
    RISK_REGISTERS: '/risk-registers',
    RISK_METRICS: '/risk-metrics',
    RISK_ALERTS: '/risk-alerts',
    
    // Compliance
    COMPLIANCE_FRAMEWORKS: '/compliance-frameworks',
    COMPLIANCE_STATUS: '/compliance-status',
    CONTROLS: '/controls',
    
    // Dashboard
    DASHBOARD_DATA: '/dashboard',
    DASHBOARD_WIDGETS: '/dashboard/widgets',
    
    // Users & Organizations
    USERS: '/users',
    ORGANIZATIONS: '/organizations',
    
    // Audit & Workflows
    AUDIT_LOGS: '/audit-logs',
    WORKFLOWS: '/workflows',
    
    // Capacity & Skills
    SKILLS: '/skills',
    SKILLS_MATRIX: '/skills-matrix',
    STAFF: '/staff',
    CUSTOMERS: '/customers',
    PROCESSES: '/processes',
    SUPPLIERS: '/suppliers'
  }
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Default headers for API requests
export const getDefaultHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };
  
  // Add auth token if available
  const token = localStorage.getItem('auth_token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

export default API_CONFIG;